import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BazisInputOptionsButtonComponent } from '@bazis/form/components/base/options/input-options-button.component';

@Component({
    selector: 'app-input-options-chip',
    templateUrl: './input-options-chip.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class InputOptionsChipComponent extends BazisInputOptionsButtonComponent {
}
